<template>
  <el-dialog
    title="楼盘描述"
    :visible.sync="dialogFormVisible"
    width="850px"
    @opened="getLoad"
    @close="resetFrom()"
    :close-on-click-modal="false"
  >
    <el-form label-width="80px" :model="editorForm" ref="editorForm">
      <el-form-item label="楼盘特色" prop="answer_analyze"> </el-form-item>
      <div id="buildingEditor"></div>

      <el-form-item label="最新动态" prop="answer_analyze"> </el-form-item>
      <div id="dynamicEditor"></div>

      <el-form-item label="交通配套" prop="answer_analyze"> </el-form-item>
      <div id="trafficEditor"></div>

      <el-form-item label="教育配套" prop="answer_analyze"> </el-form-item>
      <div id="educationEditor"></div>

      <el-form-item label="医疗健康" prop="answer_analyze"> </el-form-item>
      <div id="medicalEditor"></div>

      <el-form-item label="商业配套" prop="answer_analyze"> </el-form-item>
      <div id="businessEditor"></div>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom();
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" style="margin: 0 10px;" @click="submitEdit"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
// 导入 富文本编辑器的 构造函数
import E from 'wangeditor';
import { houseGetDescription, houseDescriptionEdit } from '@/api/houseApi.js'; //
import { getToken } from '@/utils/token.js';
export default {
  name: 'wangeditor',
  data() {
    return {
      houseId: '',
      dialogFormVisible: false,
      editorForm: {
        houseId: '',
        remark: '',
        newsInfo: '',
        trafficInfo: '',
        schoolInfo: '',
        hospitalInfo: '',
        otherInfo: '',
      },
      buildingEditor: null,
      dynamicEditor: null,
      trafficEditor: null,
      educationEditor: null,
      medicalEditor: null,
      businessEditor: null,
    };
  },
  created() {},

  methods: {
    resetFrom() {
      this.editorForm = {};

      this.destroyEditor();
    },
    getLoad() {
      houseGetDescription(this.houseId).then((res) => {
        if (res.data != null) this.editorForm = res.data;
        // 楼盘特色
        this.editorConfig('buildingEditor', this.editorForm.remark || '');
        // 最新动态
        this.editorConfig('dynamicEditor', this.editorForm.newsInfo || '');
        // 交通配套
        this.editorConfig('trafficEditor', this.editorForm.trafficInfo || '');
        // 教育配套
        this.editorConfig('educationEditor', this.editorForm.schoolInfo || '');
        // 医疗健康
        this.editorConfig('medicalEditor', this.editorForm.hospitalInfo || '');
        // 商业配套
        this.editorConfig('businessEditor', this.editorForm.otherInfo || '');
      });
    },
    editorConfig(editor, content) {
      let token = getToken();
      let newToken = JSON.parse(token);
      let _this = this;
      let instanceEditor = new E(`#${editor}`);
      instanceEditor.config.uploadImgMaxSize = '5 * 1024 * 1024'; //控制图片大小
      instanceEditor.config.uploadFileName = 'file'; // 上传参数
      instanceEditor.config.showLinkImg = false; // 隐藏插入网络图片的功能
      instanceEditor.config.uploadImgServer = `${window.RequestUrl}/upload/images/photo`; //上传图片
      instanceEditor.config.uploadImgHeaders = {
        authorization: 'Bearer ' + newToken.accessToken,
      };
      instanceEditor.create();

      // 上传图片 insertImgFn
      instanceEditor.config.uploadImgHooks = {
        // 上传图片之前
        before(xhr) {
          console.log(xhr);

          // 可阻止图片上传
          return {
            prevent: false, // 是否阻止上传
            msg: '图片上传错误',
          };
        },
        // 图片上传并返回了结果，图片插入已成功
        success(xhr) {
          console.log('success', xhr);
        },
        // 图片上传并返回了结果，但图片插入时出错了
        fail(xhr, editor, resData) {
          console.log('fail', resData);
        },
        // 上传图片出错，一般为 http 请求的错误
        error(xhr, editor, resData) {
          console.log('error', xhr, resData);
        },
        // 上传图片超时
        timeout(xhr) {
          console.log('timeout', xhr);
        },
        // 图片上传并返回了结果，想要自己把图片插入到编辑器中
        // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
        customInsert(insertImgFn, result) {
          // result 即服务端返回的接口
          console.log('customInsert', result);
          if (result.code == 200) {
            // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
            insertImgFn(result.data);
          } else {
            _this.$message.error(result.message);
          }
        },
      };
      instanceEditor.txt.append(content);
      if (editor == 'buildingEditor') {
        this.buildingEditor = instanceEditor;
      } else if (editor == 'dynamicEditor') {
        this.dynamicEditor = instanceEditor;
      } else if (editor == 'trafficEditor') {
        this.trafficEditor = instanceEditor;
      } else if (editor == 'educationEditor') {
        this.educationEditor = instanceEditor;
      } else if (editor == 'medicalEditor') {
        this.medicalEditor = instanceEditor;
      } else if (editor == 'businessEditor') {
        this.businessEditor = instanceEditor;
      }
    },
    submitEdit() {
      try {
        if (this.houseId != '') {
          // 获取编辑后的html
          this.editorForm.remark = this.buildingEditor.txt.html();
          this.editorForm.newsInfo = this.dynamicEditor.txt.html();
          this.editorForm.trafficInfo = this.trafficEditor.txt.html();
          this.editorForm.schoolInfo = this.educationEditor.txt.html();
          this.editorForm.hospitalInfo = this.medicalEditor.txt.html();
          this.editorForm.otherInfo = this.businessEditor.txt.html();

          houseDescriptionEdit(this.houseId, {
            ...this.editorForm,
          }).then((res) => {
            if (res.code === 200) {
              this.$message.success('编辑成功!');
            } else {
              this.$message.success('编辑失败!');
              return;
            }
          });
        }
        this.dialogFormVisible = false;
        this.editorForm = {};
      } catch (e) {
        window.console.log(e);
      }
    },
    destroyEditor() {
      // 销毁编辑器
      if (
        !this.buildingEditor ||
        !this.dynamicEditor ||
        !this.trafficEditor ||
        !this.educationEditor ||
        !this.medicalEditor ||
        !this.businessEditor
      )
        return;

      this.buildingEditor.destroy();
      this.buildingEditor = null;

      this.dynamicEditor.destroy();
      this.dynamicEditor = null;

      this.trafficEditor.destroy();
      this.trafficEditor = null;

      this.educationEditor.destroy();
      this.educationEditor = null;

      this.medicalEditor.destroy();
      this.medicalEditor = null;

      this.businessEditor.destroy();
      this.businessEditor = null;
    },
  },
  beforeDestroy() {
    // 销毁编辑器
    this.destroyEditor();
  },
};
</script>

<style lang="less" scoped>
.toolbar {
  border: 1px solid #ccc;
  width: 100%;
}

.el-form-item {
  margin-bottom: 5px;
}

.content {
  border: 1px solid #ccc;
  width: 100%;
  height: 200px;
}
</style>
